module.exports = __webpack_public_path__ + "static/img/cnd_municipal.075f2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/cnd_municipal.png
// module id = 832
// module chunks = 0